import { useToastStore } from '../../stores/toast'
import { X, CheckCircle, AlertCircle, AlertTriangle, Info } from 'lucide-react'
import { cn } from '../../lib/utils'

const icons = {
  success: CheckCircle,
  error: AlertCircle,
  warning: AlertTriangle,
  info: Info,
}

const styles = {
  success: 'border-success-500 bg-success-50 text-success-700',
  error: 'border-danger-500 bg-danger-50 text-danger-700',
  warning: 'border-warning-500 bg-warning-50 text-warning-700',
  info: 'border-info-500 bg-info-50 text-info-700',
}

export function ToastContainer() {
  const toasts = useToastStore((s) => s.toasts)
  const dismiss = useToastStore((s) => s.dismissToast)

  if (toasts.length === 0) return null

  return (
    <div className="fixed bottom-[calc(var(--bottom-bar-height)+0.5rem+var(--safe-area-bottom))] left-1/2 -translate-x-1/2 md:bottom-auto md:top-4 md:right-4 md:left-auto md:translate-x-0 z-toast flex flex-col gap-2 w-[calc(100vw-2rem)] max-w-sm">
      {toasts.map((toast) => {
        const Icon = icons[toast.variant]
        return (
          <div
            key={toast.id}
            className={cn(
              'flex items-start gap-3 rounded-lg border px-4 py-3 shadow-md animate-in slide-in-from-bottom-2 md:slide-in-from-top-2',
              styles[toast.variant]
            )}
          >
            <Icon className="h-5 w-5 shrink-0 mt-0.5" />
            <div className="flex-1 min-w-0">
              <p className="text-sm font-semibold">{toast.title}</p>
              {toast.description && <p className="text-sm mt-0.5 opacity-80">{toast.description}</p>}
            </div>
            <button onClick={() => dismiss(toast.id)} className="shrink-0 p-0.5 rounded hover:bg-black/10 transition-colors">
              <X className="h-4 w-4" />
            </button>
          </div>
        )
      })}
    </div>
  )
}
